import { SpectrumColor } from '../types';

export const Orange: SpectrumColor = {
  0: '#FFFAF5',
  5: '#FFF4EB',
  10: '#FFEBDA',
  15: '#FFE4CC',
  20: '#FEDCBD',
  25: '#FDCC9B',
  30: '#FABA80',
  35: '#FCAD5F',
  40: '#FCA34B',
  50: '#FF9935',
  60: '#FA8B1E',
  70: '#DC7004',
  80: '#975102',
  90: '#784000',
  100: '#5C3100',
  110: '#442400',
  default: 60,
};
